// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"1b9d76cc","381":"3b8017dc","396":"3b8017dc","685":"3b8017dc","754":"3b8017dc"}[chunkId] + ".chunk.css";
};